import { Navigate, Outlet } from 'react-router';
import { useEventListener } from 'usehooks-ts';
import BottomBar from '@/components/layouts/page-layout/bottom-bar';
import useUserPlatform from '@/hooks/use-user-platform';
import useSignOut from '@/hooks/users/use-sign-out';
import ROUTES from '@/routes';
import { useRootLayoutContext } from '@/routes/root.context';
import { useAuthStore } from '@/stores/auth';

export default function ProtectedLayout() {
  const { showFooter } = useRootLayoutContext();
  const { auth, isUserSelected, credentials } = useAuthStore();
  const { isEmbedded } = useUserPlatform();
  const { mutate: signOut } = useSignOut();

  useEventListener('keydown', (event) => {
    if (event.key === 'F5') {
      // prevent default browser refresh
      event.preventDefault();
      signOut({});
    }
  });

  if (!auth) {
    return (
      <Navigate
        replace
        to={ROUTES.AUTH.SIGN_IN.$path()}
      />
    );
  }

  if (!isEmbedded && credentials.size > 0 && !isUserSelected) {
    return (
      <Navigate
        replace
        to={ROUTES.AUTH.SWITCH.$path()}
      />
    );
  }

  return (
    <div className='desktop:ps-24 basis-full flex-col desktop:flex-row desktop:basis-auto flex-1 flex'>
      {showFooter && <BottomBar />}

      <Outlet />
    </div>
  );
}
